module.exports = __webpack_public_path__ + "static/media/22.18b7e432.mp3";